<template>
  <div class="layout-header">
    <div class="header-wrap">
      <div class="logo">
        <img src="@/assets/images/logo2.png" alt=""/>
        <!-- <img src="@/assets/images/headerlogo.png" alt="" />
        <el-divider direction="vertical"></el-divider>
        <p>用户账户中心</p> -->
      </div>
      <div class="nav">
        <ul>
          <el-button type="primary" @click="goNext(1)" icon="icon shouye0">官网首页</el-button>
          <el-button type="primary" @click="goNext(2)" icon="icon quzheng0">电子取证</el-button>
          <el-button type="primary" @click="goNext(5)" icon="icon shouji0">权利卫士APP</el-button>
          <el-button type="primary" @click="goNext(3)" icon="icon zhishi0">知识产权</el-button>
          <el-button type="primary" @click="goNext(6)" icon="icon email0">邮件认证</el-button>
          <el-button type="primary" @click="goNext(7)" icon="icon sign0">电子签名</el-button>
          <!-- <el-button type="primary" @click="goNext(4)" icon="icon qianming0"
            >电子签名</el-button
          > -->
          <!-- <el-button type="primary" @click="goNext(7)" icon="icon yizhu0"
            >遗嘱卫士</el-button
          > -->
          <!-- <el-button type="primary" @click="goNext(5)" icon="icon fuwu0"
            >时间戳公共服务</el-button
          > -->


        </ul>
      </div>
      <div class="userinfo">
        <div class="lawyer" @click="goLawyer(1)">
          找律师
        </div>
        <div class="lawyer" @click="goLawyer(2)">
          AI助手
        </div>
        <div class="lawyer" @click="goLawyer(3)">
          帮助中心
        </div>
        <i class="el-icon-bell elIcon" @click="mesClick">
          <span v-if="messageInfo.totalUnreadCount > 0"/>
        </i>
        <div class="userAccount">
          <div v-if="!isHome">
            <div class="account">
              <img :src="avatarImg" alt="" class="avatarImg" v-if="$getlocalStorage('userData').parentId === '0'">
              <img :src="avatorChildBg" alt="" class="avatarImg" v-else>{{ userinfo.loginName }}
            </div>
            <div class="my-wrap">
              <div class="my-container">
                <div class="top">
                  <div class="user">
                    <p class="avatar"><img :src="avatarImg" alt="" v-if="$getlocalStorage('userData').parentId === '0'">
                      <img :src="avatorChildBg" alt="" v-else>
                    </p>
                    <div class="real-info">
                      <p class="name">
                        <span>{{ userinfo.loginName }}</span>
                        <!--                      <b v-if="[-1,3,5].includes(authenticationStatus)">未认证</b>-->
                      </p>
                      <p class="real" v-if="$getlocalStorage('userData').parentId === '0'">
                        <span class="real-name" v-if="![-1, 3, 5].includes(authenticationStatus) && lawyerStatus !== 1">
                          <img :src="cardInfo.authentedBg"></span>
                        <span class="no-real-name"
                              v-if="![-1, 3, 5].includes(authenticationStatus) && lawyerStatus === 1">
                          <img :src="cardInfo.authentBg"></span>
                        <span class="no-real-name noReal" @click="toAuthent"
                              v-if="[-1, 3, 5].includes(authenticationStatus)">
                          <img :src="cardInfo.toAuthentBg"></span>
                        <span class="real-lawyer" v-if="lawyerStatus === 1">
                          <img :src="cardInfo.lawyerBg"></span>
                      </p>
                    </div>
                  </div>
                  <!--                <div class="center">个人中心 <i class="el-icon-arrow-right"></i>-->
                  <!--                </div>-->
                </div>

                <div class="package" v-if="$getlocalStorage('userData').parentId === '0'">
                  <div class="balance">
                    <p>时间戳余额 <b>{{ accountInfo.generalTsCount || 0 }}</b></p>
                    <span @click="cardTopBuy">去充值</span>
                  </div>
                  <PackageTypeList ref="packageTypeList"  @serviceBuy="serviceBuy"/>
                  <p class="more" @click="moreSuite"><span>查看更多套餐
                      <i class="el-icon-ali-jiantou"></i>
                    </span></p>
                </div>

                <div class="child-balance" v-if="$getlocalStorage('userData').parentId !== '0'">
                  <div class="balance parent">
                    <p><b>{{ accountInfo.generalTsCount || 0 }}</b><span>主账号通用时间戳</span></p>
                  </div>
                  <div class="balance use">
                    <p><b>{{ accountInfo.currentConsumeTsCount || 0 }}</b><span>已用时间戳</span></p>
                  </div>
                  <div class="balance current">
                    <p><b>{{
                        accountInfo.consumeLimitTsCount === -1 ? '无限制' : accountInfo.consumeLimitTsCount
                      }}</b><span>最大使用限制数</span></p>
                  </div>
                </div>
                <div class="service">
                  <div class="serviceTitle">
                    <p class="title">产品服务</p>
                    <p class="panTitle" @click="toPan">证据管理 <i class="el-icon-ali-jiantou"></i></p>
                  </div>
                  <ul :class="$getlocalStorage('userData').parentId !== '0' ? 'childUl' : ''">
                    <li v-for="(item, index) in statistics" :key="index" @click="statisticsClick(item)">
                      <p class="name">{{ item.name }}</p>
                      <dl>
                        <dt :class="item.isMax ? 'maxLength' : ''">{{ item.num }}</dt>
                        <dd>{{ item.text }}</dd>
                      </dl>
                      <p class="footer"><span>{{ item.btn }}</span> <i class="el-icon-ali-jiantou"></i>
                      </P>
                    </li>
                  </ul>
                </div>
                <div class="loginOut" @click="logout">
                  <span>退出登录</span>
                </div>
              </div>
            </div>
          </div>
          <div class="noHome" v-else>

            <el-dropdown class="systemDropdown" @command="userCommand" placement="bottom">
              <span class="account">
                <img :src="avatarImg" alt="" class="avatarImg" v-if="$getlocalStorage('userData').parentId === '0'">
                <img :src="avatorChildBg" alt="" class="avatarImg" v-else>
                <span class="loginName"> {{ userinfo.loginName }}</span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="navMask" v-if="navBarMaskShow" @click="$store.dispatch('routerInfo/setNavBarMask')"></div>
  </div>
</template>

<script>
import {
  mesClearUnread,
  mesUnreadCount,
} from "@http/message";
import {identification} from "@http/user_center/userInfo";
import {getLawyerStatus} from '@/http/modules/lawcase'
import {convertToDiscount} from "@/utils/filter";
import {statisticsCount} from "@http/common";
import {overviewNum, overviewChildNum} from "@http/overview/index";
import {mapState} from "vuex";
import MyInputNumber from "@com/basics/InputNumber/index.vue";
import PackageTypeList from '@/views/layout/components/packageTypeList'

export default {
  name: "Header",
  data() {
    return {
      activeIndex: "1",
      messageInfo: {},
      avatarImg: require('@/assets/images/newHome/avator.png'),
      avatorChildBg: require('@/assets/images/newHome/avatorChild.png'),
      cardInfo: {
        serviceList: [],
        avatarImg: require('@/assets/images/newHome/avator.png'),
        avatorChildBg: require('@/assets/images/newHome/avatorChild.png'),
        lawyerBg: require('@/assets/images/newHome/lawyer.png'),
        authentedBg: require('@/assets/images/newHome/authented.png'),
        authentBg: require('@/assets/images/newHome/authent.png'),
        toAuthentBg: require('@/assets/images/newHome/toAuthent.png'),
      },
      authenticationStatus: '',
      lawyerStatus: '',
      convertToDiscount,
      accountInfo: {},
      statistics: {},
      isHome: true,
      chooseId: "",
    };
  },
  mixins: [],
  components: {MyInputNumber, PackageTypeList},
  watch: {
    $route(to, from) {
      this.isHome = this.$store.state.routerInfo.basicPath === "/Home";
      if (!this.isHome) {
        this.getOverviewNum();
        setTimeout(()=>{
          this.$refs.packageTypeList.dealListCommon()
        },100)
      }
    },
    "$store.state.userInfo.isClean": {
      handler(newFlag, oldFlag) {
        this.getOverviewNum();
      },
      deep: true
    },

  },
  computed: {
    ...mapState({
      navBarMaskShow: (state) => state.routerInfo.navBarMaskShow,
    }),
    userinfo: {
      get() {
        return this.$store.state.userInfo.userinfo;
      },
      set(val) {
        this.$store.state.userInfo.userinfo = val;
      },
    },
    channelCodeValue() {
      return this.$store.state.config.channelCodeValue;
    },
  },
  created() {
    this.initMes()
  },
  mounted() {
    this.getRouter();
  },

  methods: {
    goLawyer(type) {
      let sourceType = this.$getlocalStorage("queryData")?.sourceType || this.$getlocalStorage("queryData")?.clientId || 975260;
      switch (type) {
        case 1:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '找律师'})
          window.open(`${process.env.VUE_APP_LAWCASE}/userCenter/findLawyer?location=user_navi&sourceType=` + sourceType);
          break;
        case 2:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': 'AI助手'})
          window.open(`${process.env.VUE_APP_AI}?location=user_navi&sourceType=` + sourceType);
          break;
        case 3:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '帮助中心'})
          window.open(`${process.env.VUE_APP_TSA}/baike.html?location=user_navi&sourceType=` + sourceType);
          break;
      }

    },
    goNext(n) {
      switch (n) {
        case 1:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '官网首页'})
          window.open(process.env.VUE_APP_TSA);
          break;
        case 2:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '电子取证'})
          window.open(process.env.VUE_APP_EV + '/vm_fetch');
          break;
        case 3:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '知识产权'})
          window.open(process.env.VUE_APP_COPYRIGHT + '/system/index/copyright');
          break;
          // case 4:
          //     zhuge.track('用户中心_导航进电子签名', {'渠道': this.channelCodeValue})
          //   window.open(process.env.VUE_APP_SIGN);
          //   break;
        case 5:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '权利卫士'})
          window.open(process.env.VUE_APP_TSA + '/quanliweishi.html');
          break;
        case 6:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '邮件认证'})
          window.open(process.env.VUE_APP_EMAIL + '/emailProof/witnessEmail');
          break;
        case 7:
          zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '电子签名'})
          window.open(process.env.VUE_APP_SIGN);
          break;
      }
      // window.open(data)
    },
    userCommand(command) {
      var that = this;
      if (command == "editpwd") {
        zhuge.track('用户中心_导航修改密码', {'渠道': this.channelCodeValue}, () => {
          this.$router.push({path: "/userCenter/security"}) //继续跳转到目标页面
        })
      }
      if (command == "logout") {
        that.$store.commit("userInfo/setuserinfo", null);
        localStorage.removeItem("queryData");
        zhuge.track('用户中心_导航退出登录', {'渠道': this.channelCodeValue}, () => {
          window.location.href = "/api/logout";
          window.sessionStorage.removeItem('couponId')
        })
      }
    },
    logout() {
      var that = this;
      that.$store.commit("userInfo/setuserinfo", null);
      localStorage.removeItem("queryData");
      zhuge.track('用户中心_个人中心气泡', {'渠道': this.channelCodeValue, '按钮名称': '退出登录'}, () => {
        window.location.href = "/api/logout";
        window.sessionStorage.removeItem('couponId')
      })
    },
    async initMes() {
      let res = await mesUnreadCount()
      this.messageInfo = res
    },
    mesClick() {
      zhuge.track('用户中心_点击顶部导航', {'渠道': this.channelCodeValue, '按钮名称': '消息'})
      this.$router.push({path: "/messageCenter/history"})
    },
    // 获取时间戳
    async getOverviewNum() {
      if (this.$getlocalStorage('userData').parentId == '0') {
        this.accountInfo = await overviewNum({});
      } else {
        this.accountInfo = await overviewChildNum({});
      }
      statisticsCount().then(res => {
        let dataList = [
          {
            name: '电子取证',
            num: res.evTotal || res.evTotal === 0 ? res.evTotal : NaN,
            isMax: res.evTotal || res.evTotal === 0 ? !!(res.evTotal.toString().length > 5) : '',
            text: '证据文件',
            btn: '立即取证',
            path: process.env.VUE_APP_EV + `/vm_fetch`,
          },
          {
            name: '原创保护',
            num: res.opusTotal || res.opusTotal === 0 ? res.opusTotal : NaN,
            isMax: res.opusTotal || res.opusTotal === 0 ? !!(res.opusTotal.toString().length > 5) : '',
            text: '已保护文件',
            btn: '立即保护',
            path: process.env.VUE_APP_COPYRIGHT + `/time/ApplyTime`,
          },
          {
            name: '权利卫士',
            num: res.rightsTotal || res.rightsTotal === 0 ? res.rightsTotal : NaN,
            isMax: res.rightsTotal || res.rightsTotal === 0 ? !!(res.rightsTotal.toString().length > 5) : '',
            text: '证据文件',
            btn: '立即查看',
            path: process.env.VUE_APP_EV + `/qlws`,
          },
          {
            name: '邮件认证',
            isMax: res.emailProofTotal || res.emailProofTotal === 0 ? !!(res.emailProofTotal.toString().length > 5) : '',
            num: res.emailProofTotal || res.emailProofTotal === 0 ? res.emailProofTotal : NaN,
            text: '证据文件',
            btn: '立即认证',
            path: process.env.VUE_APP_EMAIL + `/emailProof/witnessEmail`,
          },
        ]
        if (this.$getlocalStorage('userData').parentId !== '0') {
          dataList = dataList.slice(0, 3)
        }
        this.statistics = dataList
      }).catch(err => {
        console.log(err)
      })
      identification({hiddenApproval: true}).then((res) => {
        this.authenticationStatus = res.authenticationStatus;
      }).catch((err) => {
        console.log(err);
      });
      getLawyerStatus().then(res => {
        this.lawyerStatus = res.status;
      }).catch(err => {
        console.log(err)
      })
    },
    statisticsClick(item) {
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': item.btn,
        '产品服务名称': item.name,
      })
      window.open(item.path + `?sourceType=975260`)
    },
    serviceBuy(item) {
      this.$router.push({path: '/userAccount/buy', query: {suiteId: item.id}})
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': `买${item.tsCount}个送${item.presentedTsCount}个`,
      })
    },
    // 实名认证
    toAuthent() {
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': '去认证',
      })
      this.$router.push({path: '/userCenter/authenticationName'})
    },
    // 右侧顶部充值
    cardTopBuy() {
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': '去充值',
      })
      this.$router.push({path: '/userAccount/buy'})
    },
    // 更多套餐
    moreSuite() {
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': '更多套餐',
      })
      this.$router.push({path: '/userAccount/buy'})
    },
    getRouter() {
      this.isHome = this.$route.path === "/Home";
      if (!this.isHome) {
        this.getOverviewNum();
        console.log(this.$refs.packageTypeList)
        setTimeout(()=>{
          this.$refs.packageTypeList.dealListCommon()
        },100)
      }
    },
    toPan() {
      window.open(process.env.VUE_APP_PAN)
      zhuge.track('用户中心_个人中心气泡', {
        '渠道': this.channelCodeValue,
        '按钮名称': '证据管理',
      })
    }
  },
};
</script>
<style scoped lang="less">
.layout-header {
  position: relative;
}

.header-wrap {
  display: flex;
  flex-direction: row;
  height: 60px;
  // border: 1px solid #e3e3e5;
  background: #fff;
  border-top: none;
  box-shadow: 0px 7px 8px 0px rgba(0, 0, 0, 0.06);

  .logo {
    margin-left: 134px;
    display: flex;
    flex-direction: row;
    line-height: 80px;
    justify-content: flex-end;
    padding-right: 30px;
    align-items: center;
    z-index: 999;

    img {
      height: 40px;
      float: left;
    }

    p {
      width: 100px;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      float: left;
    }
  }
}

.nav {
  font-size: 16px;
  flex: 8;

}

.nav ul {
  display: flex;
  flex-direction: row;
  line-height: 80px;
  justify-content: flex-start;
  //padding-right: 30px;
  align-items: center;
}

.nav ul {
  padding-right: 30px;

  /deep/ .el-button {
    border-radius: 0;
    height: 60px;
    margin-left: 0;
    background-color: #fff;
    border-color: #fff;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    padding: 8px 14px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &:hover {
      // background-color: #409eff;
      // border-color: #409eff;
      color: #409eff;
    }

    // &:nth-child(1):hover {
    //   .shouye0 {
    //     background: url("../../icons/svg/1shouye.png") center no-repeat;
    //     background-size: 20px;
    //   }
    // }

    // &:nth-child(2):hover {
    //   .quzheng0 {
    //     background: url("../../icons/svg/1quzheng.png") center no-repeat;
    //     background-size: 22px;
    //   }
    // }

    // &:nth-child(3):hover {
    //   .zhishi0 {
    //     background: url("../../icons/svg/1zhishi.png") center no-repeat;
    //     background-size: 17px;
    //   }
    // }

    // &:nth-child(4):hover {
    //   .qianming0 {
    //     background: url("../../icons/svg/1qianming.png") center no-repeat;
    //     background-size: 19px;
    //   }
    // }

    // &:nth-child(5):hover {
    //   .shouji0 {
    //     background: url("../../icons/svg/1shouji.png") center no-repeat;
    //     background-size: 12px;
    //   }
    // }
    span {
      font-size: 16px;
    }
  }

  /deep/ .shouye0 {
    background: url("../../icons/ico/shouye.png") center no-repeat;
  }

  /deep/ .quzheng0 {
    background: url("../../icons/ico/quzheng.png") center no-repeat;
  }

  /deep/ .zhishi0 {
    background: url("../../icons/ico/zhishi.png") center no-repeat;
  }

  /deep/ .email0 {
    background: url("../../icons/ico/emailIco.png") center no-repeat;
  }

  /deep/ .qianming0 {
    background: url("../../icons/ico/qianming.png") center no-repeat;
  }

  /deep/ .shouji0 {
    background: url("../../icons/ico/shouji.png") center no-repeat;
  }

  /deep/ .fuwu0 {
    background: url("../../icons/ico/fuwu.png") center no-repeat;
  }

  /deep/ .fuwu0 {
    background: url("../../icons/ico/fuwu.png") center no-repeat;
  }

  /deep/ .sign0 {
    background: url("../../icons/ico/signLogo.png") center no-repeat;
    background-size: 20px;
  }

  /deep/ .icon {
    margin-right: 10px;
    font-size: 24px;
  }

  /deep/ .icon:before {
    content: "替";
    font-size: 20px;
    visibility: hidden;
  }


  // /deep/ .shouji0:before {
  //   font-size: 12px;
  // }

  // /deep/ .quzheng0:before {
  //   font-size: 24px;
  // }
}

.nav ul li a {
  color: #333;
}

.nav ul li a:hover {
  color: #6288fb;
}

.userinfo {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-right: 1.5%;
  padding: 0 15px 0 0;

  .lawyer {
    cursor: pointer;
    font-size: 14px;
    margin: 0 10px 0 0;
    padding: 8px 1%;
    background: #fff;
    border-radius: 18px;
    border: 1px solid #E5E6EB;
    color: #333;
    text-align: center;
    transition: all .3s ease;
    min-width: 73px;

    &:hover {
      color: #0047FF;
      border-color: #0047FF;
    }
  }

  .elIcon {
    border: 1px solid #E5E6EB;
    font-size: 14px;
    padding: 8px;
    cursor: pointer;
    border-radius: 50%;
    transition: all .3s ease;
    position: relative;

    &:hover {
      color: #0047FF;
      border-color: #0047FF;
    }

    span {
      position: absolute;
      right: 0;
      top: 0;
      background: #F53F3F;
      padding: 4px;
      border-radius: 50%;
    }
  }

  .system-user {
    vertical-align: middle;
    border-radius: 8px;
  }

  .quit {
    vertical-align: middle;
  }
}

.userinfo .account {
  vertical-align: middle;
  display: inline-block !important;
  padding: 0 0 0 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 64px;
  line-height: 64px;
}

.avatarImg {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 4px;
  margin-top: 16px;
  float: left;
}

.userinfo .account:hover {
  color: #6288fb;
}

.my-el-menu .el-menu-item {
  color: #333;
}

.userAccount {
  &:hover {
    .my-wrap {
      display: block;
    }
  }
}

.account {
  display: block;
  text-overflow: ellipsis;
  //overflow: hidden;
  word-break: break-word;
  white-space: nowrap;


}

.my-wrap {
  z-index: 999;
  position: absolute;
  top: 54px;
  right: 0;
  padding-top: 4px;
  display: none;

  .my-container {
    width: 484px;
    background: linear-gradient(180deg, #FFFFFF 0%, #F7F9FD 100%);
    box-shadow: 0px 4px 20px 0px rgba(0, 71, 255, 0.1);
    border-radius: 20px;
    padding: 16px;
    box-sizing: border-box;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .user {
        flex: 1;
        display: flex;
        align-items: center;

        .avatar {
          margin-right: 24px;

          img {
            display: block;
            width: 56px;
            height: 56px;
            border-radius: 28px;
          }
        }

        .real-info {
          flex: 1;

          .name {
            display: flex;
            align-items: center;

            span {
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
              font-size: 18px;
              color: #000;
            }

            b {
              margin-left: 10px;
              font-size: 12px;
              color: #999;
              background-color: #EEEEEE;
              width: 52px;
              height: 21px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 11px;
            }
          }

          .no-real {
            margin-top: 8px;
            background: rgba(0, 71, 255, 0.1);
            width: 113px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #0047FF;
            border-radius: 16px;
            cursor: pointer;
          }

          .real {
            margin-top: 8px;
            display: flex;

            span {
              width: 72px;
              height: 25px;
              display: flex;
              font-size: 12px;
              color: #EDC6A5;
              border-radius: 13px;

              img {
                height: 25px;
                display: block;
                margin-right: 6px;
              }
            }

            .noReal {
              width: auto;
              cursor: pointer;

              span {
              }
            }
          }
        }

      }

      .center {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #000;

        i {
          font-size: 20px;
        }

        &:hover {
          color: #0047FF;

          i {
            color: #0047FF;
          }
        }
      }
    }

    .child-balance {
      margin-top: 24px;
      padding: 12px 12px;
      background: linear-gradient(132deg, rgba(241, 243, 255, 1) 0%, rgba(236, 246, 255, 1) 100%);
      border-radius: 16px;
      justify-content: space-around;
      display: flex;

      .balance {
        p {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000;
          font-weight: bold;

          span {
            font-size: 14px;
          }

          b {
            font-size: 24px;
            margin-bottom: 6px;
          }
        }
      }
    }

    .package {
      margin-top: 24px;
      padding: 16px 12px;
      background: linear-gradient(132deg, #F2F3FF 0%, #ECF6FF 100%);
      border-radius: 16px;

      .balance {
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #000;
          font-weight: bold;

          b {
            margin-left: 34px;
            font-size: 24px;
          }
        }

        span {
          width: 90px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          border-radius: 18px;
          font-size: 14px;
          color: #0047FF;
          background: #fff;
          cursor: pointer;

          &:hover {
            background: #0047FF;
            color: #fff;
          }
        }
      }
      /deep/.package-type-list {
        .package-type {
          ul{
            padding-top: 20px;
          }
        }}
      .more {
        padding-top: 5px;
        display: flex;
        justify-content: center;

        span {
          display: flex;
          align-items: center;
          color: #666;
          font-size: 14px;
          cursor: pointer;

          i {
            font-size: 20px;
            margin-top: 3px;
          }

          &:hover {
            color: #0047FF;
          }
        }
      }
    }


    .service {
      margin-top: 14px;
      border-radius: 16px;
      background-color: #fff;
      padding: 16px 12px;

      .serviceTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          font-size: 16px;
          color: #000;
          font-weight: bold;
          text-align: left;
        }

        .panTitle {
          cursor: pointer;

          &:hover {
            color: #0047FF;
          }
        }
      }


      ul {
        padding-top: 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        li {
          cursor: pointer;
          list-style: none;
          width: 101px;
          height: 122px;
          background: linear-gradient(132deg, #F2F3FF 0%, #ECF6FF 100%);
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .name {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #000;
            width: 73px;
            height: 25px;
            border-radius: 0 0 8px 8px;
            background: #E0EAFF;
          }

          dl {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #000;
            text-align: center;

            dt {
              font-size: 32px;
              font-weight: bold;
            }

            dd {
              font-size: 14px;
            }

            .maxLength {
              font-size: 24px;
              height: 37px;
              line-height: 39px;
            }
          }

          .footer {
            border-radius: 0 0 8px 8px;
            width: 100%;
            height: 29px;
            background: #E0EAFF;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              display: block;
              font-size: 12px;
              background-image: linear-gradient(270deg, #2377FF 0%, #0047FF 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              mask-image: -webkit-linear-gradient(270deg, #2377FF 0%, #0047FF 100%);
            }

            i {
              color: #0047FF;
              font-size: 16px;
            }
          }
        }
      }

      .childUl {
        li {
          width: 138px;
        }
      }
    }

    .loginOut {
      padding: 18px 0 0;

      span {
        text-align: center;
        width: 100px;
        margin: 0 auto;
        display: block;
        cursor: pointer;
        color: #666666;
        font-size: 16px;

        &:hover {
          color: #0047FF;
        }
      }

    }
  }
}

.ico {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 4px !important;
}

/deep/ .el-dropdown-menu {
  border-radius: 8px;
}

@media screen and (max-width: 1680px) {
  .header-wrap {
    .logo {
      img {
        height: 25px;
      }
    }
  }

  .nav {
    flex: 6;

    ul {
      padding-right: 15px;

      /deep/ .el-button {
        padding: 8px 12px;

        .icon {
          display: none !important;
        }

        span {
          font-size: 12px;
        }
      }
    }
  }

  .userinfo {
    font-size: 12px !important;

    .lawyer {
      min-width: 57px;
      padding: 8px 1%;
      font-size: 12px;
    }
  }
}

.noHome {
  display: flex;
  align-items: center;
  justify-content: center;

  .loginName {
    white-space: nowrap;
    cursor: pointer;
  }
}

.el-dropdown-menu {
  border-radius: 8px;
  top: 50px !important;
}
</style>
